module.exports = __webpack_public_path__ + "static/media/discard-delete-disable.1b143dbf.svg";